export const onLoad = (name = 'UNKNOWN') => ({
    type: `${name.toUpperCase()}_LOAD_PAGE`
});

export const onUnload = (name = 'UNKNOWN') => ({
    type: `${name.toUpperCase()}_UNLOAD_PAGE`
});
